module["exports"] = [
  "Polska"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pl/address/default_country.js
 ** module id = 908
 ** module chunks = 0
 **/